import React from 'react';
import GraphPreloader from './GraphPreloader';
export default function Lifecycle() {
    return (React.createElement(React.Fragment, null,
        React.createElement(GraphPreloader, null)));
}
